import { useInteraction } from '@mercadoni/sinister/dist/cjs/monitors'
import { UseListContext } from '@mercadoni/sinister/dist/cjs/shoppingLists'

import useGuessAction from '../../../hooks/useGuessAction'

import goToProductVariants from '@/navigation/CSR/goToProductVariants'
import { goToPromoTag } from '@/navigation/CSR/goToPromoTag'
import { ProductCtrlsProps, ProductPayload } from '~types/index'

const useProductCtrls = ({
  sendEventSelectProduct,
  router,
  clientConfig,
}: ProductCtrlsProps) => {
  const { favoriteService } = UseListContext()
  const { sendInteractionEvent } = useInteraction()

  const onCarlessProduct = useGuessAction({ router, forceToLogin: false })
  const onClickProductPromoTag = ({ tag }: ProductPayload) =>
    goToPromoTag(router, tag)

  const onClickProduct = ({ product, category }: ProductPayload) => {
    if (!product) {
      return
    }
    sendEventSelectProduct({ product, category })
  }
  const onInteractionProduct = ({
    product,
    interactionName,
  }: {
    product: any
    interactionName: string
  }) => {
    sendInteractionEvent({ interactionName })

    goToProductVariants({ router, product, clientConfig: clientConfig })
  }

  return {
    favoriteService,
    onClickProduct,
    onClickProductPromoTag,
    onCarlessProduct,
    onInteractionProduct,
  }
}
export default useProductCtrls
